import { Button } from '@mantine/core';
import pdfMake from "pdfmake/build/pdfmake";
import { Content, TDocumentDefinitions } from 'pdfmake/interfaces';
import React from 'react';

interface HashPrintProps {
    allocationData: any;
}

const HashPrint: React.FC<HashPrintProps> = ({ allocationData }) => {
    const handlePrintHash = async () => {
        try {
            if (!allocationData) {
                alert('Please select a Po first');
                return
            }
            let pdfData: { store: string, totalQty?: number, storeData: any }[] = [];
            allocationData.forEach((item: any) => {
                item.storeName.forEach((store: any, index: number) => {
                    const existingStore = pdfData.findIndex((itm: any) => itm.store === store);
                    const quantity = item.sizeQuantities[index].reduce((total: number, sizeData: { quantity: number }) => total + sizeData.quantity, 0);
                    if (quantity !== 0) {
                        if (existingStore !== -1) {
                            pdfData[existingStore].storeData.push({
                                style_no: item.style_no,
                                qty: quantity
                            })
                        } else {
                            pdfData.push({
                                store: store,
                                storeData: [{
                                    style_no: item.style_no,
                                    qty: quantity
                                }]
                            })
                        }
                    }
                })
            })
            generatePDF(pdfData);
        } catch (error) {
            console.log(`Error :`, error);
        }
    }
    const chunkArray = (arr: any[], size: number) => {
        const result = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    };

    const generatePDF = (pdfData: any) => {
        let contentData: Content[] = [];
        let storePage: Content[] = [];

        pdfData.forEach((storeData: any, index: number) => {
            const chunks = chunkArray(storeData.storeData, 27); // Break rows into chunks of 27

            chunks.forEach((chunk: any[], chunkIndex: number) => {
                const isLastPage = index === pdfData.length - 1 && chunkIndex === chunks.length - 1;
                const tableBody: any = [
                    [
                        { text: 'No', bold: true, alignment: 'center', fontSize: 18 },
                        { text: 'Style No', bold: true, alignment: 'center', fontSize: 18 },
                        { text: 'Quantity', bold: true, alignment: 'center', fontSize: 18 }
                    ],
                    ...chunk.map((item: any, i: number) => {
                        const actualIndex = chunkIndex * 27 + i;
                        const fillColor = actualIndex % 2 === 0 ? '#e0e0e0' : undefined; // ok

                        if (!item.style_no || !item.qty) {
                            console.error('Invalid data found in row:', item);
                            return [
                                { text: 'Invalid', fillColor },
                                { text: 'Invalid', fillColor },
                                { text: '', fillColor }
                            ];
                        }

                        return [
                            { text: `${actualIndex + 1}`, alignment: 'center', fontSize: 14, fillColor },
                            { text: item.style_no, alignment: 'center', fontSize: 14, fillColor },
                            { text: item.qty, alignment: 'center', fontSize: 14, fillColor }
                        ];
                    }),
                ];
                storePage = [
                    { text: `${allocationData[0]?.po_no}`, fontSize: 18, bold: true, alignment: 'center' },
                    {
                        table: {
                            widths: ['*', '*'],
                            heights: [30, 30],
                            body: [
                                [
                                    {
                                        table: {
                                            widths: ['33%', '33%', '34%'],
                                            body: [
                                                [
                                                    { text: `Styles: ${storeData.storeData.length}`, fontSize: 18, bold: true, fillColor: '#e0e0e0', alignment: 'center' },
                                                    { text: `QTY: ${storeData.storeData.reduce((total: number, item: any) => total + (item.qty || 0), 0)}`, fontSize: 18, bold: true, alignment: 'center' },
                                                    { text: storeData.store, bold: true, color: 'red', fontSize: 20, alignment: 'center' }
                                                ]
                                            ]
                                        },
                                        layout: {
                                            defaultBorder: true
                                        },
                                        colSpan: 2
                                    },
                                    {}
                                ],
                                [
                                    { text: `Date: ${new Date().toLocaleDateString()}`, fontSize: 20, bold: true, border: [false, false, false, false] },
                                    { text: `Box No:                /      `, fontSize: 20, bold: true, border: [false, false, false, false] }
                                ]
                            ]
                        },
                        layout: {
                            hLineWidth: () => 0.5,
                            vLineWidth: () => 0.5,
                            hLineColor: () => '#000000',
                            vLineColor: () => '#000000',
                            defaultBorder: false
                        }
                    },
                    {
                        table: {
                            widths: [30, '*', 80],
                            headerRows: 1,
                            body: tableBody
                        },
                        layout: {
                            hLineColor: () => '#000000',
                            vLineColor: () => '#000000',
                            defaultBorder: true
                        },
                        pageBreak: isLastPage ? undefined : 'after'
                    }
                ];
                contentData.push(storePage);
            })
        });


        const docDefinition: TDocumentDefinitions = {
            content: contentData,
            pageSize: 'LETTER',
            pageOrientation: 'portrait',
        };

        pdfMake.createPdf(docDefinition).open();
    };

    return (
        <Button className={'btn'} onClick={handlePrintHash}>Print Hash</Button>
    )
}

export default HashPrint;